import React, { useState } from 'react';
function IdealWeight({ result}) {
  return (
    <table >
      <thead>
        <tr>
          <th >الصيغة/المعادلة</th>
          <th > الوزن المثالي</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td>Hamwi (1964)	</td>
          <td>{result.hamwi} كغ</td>
        </tr>
        <tr >
          <td>Devine (1974)	 </td>
          <td>{result.devine} كغ </td>
        </tr>
        <tr >
          <td>Robinson (1983)</td>
          <td>{result.robinson} كغ</td>
        </tr>
        <tr >
        <td>
        Miller (1983)
          </td>
          <td>{result.miller} كغ</td>
        </tr>
        <tr >
          <td>مؤشر كتلة الجسم (BMI) الصحي</td>
          <td>{result.bmiRange.lower} - {result.bmiRange.upper} كغ </td>
        </tr>
      </tbody>
    </table>
  );
}
export default IdealWeight;
